import { render, staticRenderFns } from "./MaterialAutocomplete.vue.js?vue&type=template&id=53f46e6a&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialAutocomplete.vue?vue&type=template&id=53f46e6a&scoped=true"
import script from "./MaterialAutocomplete.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialAutocomplete.vue?vue&type=script&lang=js"
export * from "./MaterialAutocomplete.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f46e6a",
  null
  
)

export default component.exports